import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { loginWithFacebook } from 'services/auth/identities/facebook'
import { facebookSDKInitializedSelector } from 'services/external/selectors'
import { StoreThunkDispatch } from 'store/state'
import LoginButton from './LoginButton'
import styles from './LoginButton.pcss'

interface FBAllowPermissionsButtonProps {
  className?: string
  onClick?: () => void
}

export default function FBAllowPermissionsButton(props: FBAllowPermissionsButtonProps) {
  const { className, onClick } = props
  const dispatch = useDispatch<StoreThunkDispatch>()
  const intl = useIntl()
  const initialized = useSelector(facebookSDKInitializedSelector)

  const onLogin = useCallback(() => {
    if (onClick) {
      onClick()
    }
    return dispatch(loginWithFacebook(false, { auth_type: 'rerequest' }))
  }, [dispatch, onClick])

  return (
    <LoginButton
      initialized={initialized}
      buttonClassName={styles.reauth}
      progressClassName={styles.progress}
      displayInitialized={intl.formatMessage({ id: 'login.allow-email-perm' })}
      className={className}
      onLogin={onLogin}
    />
  )
}
